import script from "./AuthSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthSection.vue?vue&type=script&setup=true&lang=js"

import "./AuthSection.vue?vue&type=style&index=0&id=116cc197&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-116cc197"]])

export default __exports__